"use strict";

import $ from "jquery";

export function initInScope ($scope) {
    console.log("init res");
    let form = $scope.find('.js-submit-res');
    form.on('submit', function (e) {
        e.preventDefault();
        if (!$(this).parsley().validate()) {
            return false;
        }
        if($(this).data('loggedin') === 1) {
            this.submit();
        } else {
            $('#loginOrRegModal').modal('show');
            $(this).find('button[type="submit"]').removeAttr("disabled");
        }
        return false;
    });

    let inSummary = form.data("in-summary") === 1;
    if(inSummary) {
        let saved = sessionStorage.getItem('summaryForm');
        if (saved) {
            let savedData = JSON.parse(saved);
            $('#aufenthalt').val(savedData.aufenthalt);
            $('input[name="agb"]').prop('checked', savedData.agb);
            $('input[name="wiederruf"]').prop('checked', savedData.wiederruf);
            console.log("savedData", savedData);
            sessionStorage.removeItem('summaryForm');
            $(".loading-overlay").show();
            form.find('button[type="submit"]').click();
        }
    }
}



